import React, { useMemo } from 'react';

import { TFunction } from 'i18next';
import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withHomeScreenRetentionLayout,
  withMainExtensionLayout,
  withOnboardingLayout,
  withPromoModalLayout,
  withSimpleHeaderLogoLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  ExtensionAuthPath,
  ExtensionOffboardingPath,
  ExtensionOnboardingPath,
  ExtensionPath,
} from '~/modules/extension/constants';
import extension from '~/services/Extension';

const Onboarding = lazyComponentLoader(() => import('./views/Onboarding'));

const Overview = lazyComponentLoader(() => import('./views/Overview'));

const ExtensionOffboarding = lazyComponentLoader(
  () => import('./views/Offboarding'),
);

const ExtensionAuth = lazyComponentLoader(() => import('./views/Auth'));

const getTitle = (t: TFunction): string => {
  return t('sidebar:extension_v1', {
    extension_name: extension.getTitle(),
    defaultValue: '{{extension_name}} Extension',
  });
};

export const ExtensionOnboardingRoute: RouteItemType = {
  Component: flowRight(withSimpleHeaderLogoLayout)(Onboarding),
  path: ExtensionOnboardingPath,
  getTitle,
};

export const ExtensionRoute: RouteItemType = {
  Component: () => {
    const WrappedComponent = useMemo(() => {
      const layouts = [
        withPromoModalLayout,
        withSubModalsLayout,
        withOnboardingLayout,
        withHomeScreenRetentionLayout,
        withMainExtensionLayout,
      ];

      return flowRight(...layouts)(Overview);
    }, []);

    return <WrappedComponent />;
  },
  checkAvailability: () => extension.checkIsExtensionAvailable(),
  path: ExtensionPath,
  getTitle,
};

export const ExtensionOffboardingRoute: RouteItemType = {
  Component: ExtensionOffboarding,
  path: ExtensionOffboardingPath,
  getTitle,
  checkAvailability: () => extension.checkIsExtensionAvailable(),
};

export const ExtensionAuthRoute: RouteItemType = {
  Component: ExtensionAuth,
  path: ExtensionAuthPath,
  getTitle,
};
